  (() => {
  const currentScript = document.currentScript;
  const scriptSectionId = currentScript?.dataset.sectionId;

  if (!scriptSectionId) {
    console.error('AW Style File: section id not found');
    return;
  }

  const section = document.querySelector(
    `[data-aw-style-file][data-section-id="${scriptSectionId}"]`
  );

  if (!section || section.dataset.initialized === 'true') {
    return;
  }

    section.dataset.initialized = 'true';

    const dataElement =
      section.querySelector('[data-style-data]');

    const grid =
      section.querySelector('[data-style-grid]');

    const filterButtons =
      section.querySelectorAll('[data-style-length]');

    if (!dataElement || !grid) {
      return;
    }

    const sectionId =
      section.dataset.sectionId;

    const totalPages =
      Number(dataElement.dataset.sourcePages || 1);

    const sourceTotal =
      Number(dataElement.dataset.sourceTotal || 0);

    const pageParam =
      dataElement.dataset.sourcePageParam || 'page';

    const parseStyles = (element) => {
      if (!element) {
        return [];
      }

      try {
        const parsed =
          JSON.parse(element.textContent);

        return Array.isArray(parsed)
          ? parsed
          : [];
      } catch (error) {
        console.error(
          'AW Style File: JSON parse error',
          error
        );

        return [];
      }
    };

    const getDisplayOrder = (style) => {
      const value =
        Number(style.displayOrder);

      if (!Number.isFinite(value)) {
        return Number.MAX_SAFE_INTEGER;
      }

      return value;
    };

    const sortStylesByDisplayOrder = (
      styleList
    ) => {
      return styleList
        .map((style, index) => ({
          style,
          index
        }))
        .sort((a, b) => {
          const orderA =
            getDisplayOrder(a.style);

          const orderB =
            getDisplayOrder(b.style);

          if (orderA !== orderB) {
            return orderA - orderB;
          }

          return a.index - b.index;
        })
        .map((item) => item.style);
    };

    let styles =
      sortStylesByDisplayOrder(
        parseStyles(dataElement)
      );

    let activeLength =
      'all';

    const getDisplayLimit = () => {
      return window
        .matchMedia('(min-width: 990px)')
        .matches
        ? 5
        : 6;
    };

    const isNewStyle = (
      publishedAt
    ) => {
      if (!publishedAt) {
        return false;
      }

      const publishedDate =
        new Date(publishedAt);

      if (
        Number.isNaN(
          publishedDate.getTime()
        )
      ) {
        return false;
      }

      const now =
        new Date();

      const elapsed =
        now.getTime() -
        publishedDate.getTime();

      const thirtyDays =
        30 *
        24 *
        60 *
        60 *
        1000;

      return (
        elapsed >= 0 &&
        elapsed < thirtyDays
      );
    };

    const createImage = (
      style
    ) => {
      const imageWrap =
        document.createElement('div');

      imageWrap.className =
        'aw-style-file__image-wrap';

      if (!style.image) {
        imageWrap.classList.add(
          'aw-style-file__image-wrap--empty'
        );

        return imageWrap;
      }

      const image =
        document.createElement('img');

      image.className =
        'aw-style-file__image';

      image.src =
        style.image;

      if (
        /[?&]width=\d+/.test(
          style.image
        )
      ) {
        image.srcset =
          [360, 540, 720, 900]
            .map(
              (width) =>
                style.image.replace(
                  /([?&])width=\d+/,
                  '$1width=' + width
                ) +
                ' ' +
                width +
                'w'
            )
            .join(', ');

        image.sizes =
          '(min-width: 990px) calc((83.34vw - 32px) / 5), ' +
          '(min-width: 750px) calc((83.34vw - 16px) / 3), ' +
          'calc((96.36vw - 32px) / 2)';
      }

      image.alt =
        style.imageAlt ||
        style.title ||
        '';

      image.loading =
        'lazy';

      image.decoding =
        'async';

      imageWrap.appendChild(
        image
      );

      return imageWrap;
    };

    const createCard = (
      style
    ) => {
      const hasUrl =
        style.url &&
        style.url !== '#';

      const card =
        document.createElement(
          hasUrl
            ? 'a'
            : 'div'
        );

      card.className =
        'aw-style-file__card';

      card.dataset.styleCard =
        '';

      card.dataset.styleLength =
        style.length || '';

      if (hasUrl) {
        card.href =
          style.url;
      }

      card.appendChild(
        createImage(style)
      );

      const meta =
        document.createElement('div');

      meta.className =
        'aw-style-file__meta';

      if (
        isNewStyle(
          style.publishedAt
        )
      ) {
        const newLabel =
          document.createElement('span');

        newLabel.className =
          'aw-style-file__new';

        newLabel.textContent =
          '[NEW]';

        meta.appendChild(
          newLabel
        );
      }

      if (style.title) {
        const title =
          document.createElement('p');

        title.className =
          'aw-style-file__title';

        title.textContent =
          style.title;

        meta.appendChild(
          title
        );
      }

      card.appendChild(
        meta
      );

      return card;
    };

    const getFilteredStyles = () => {
      if (
        activeLength === 'all'
      ) {
        return styles;
      }

      return styles.filter(
        (style) => {
          return (
            style.length ===
            activeLength
          );
        }
      );
    };

    const render = () => {
      const limit =
        getDisplayLimit();

      const filteredStyles =
        getFilteredStyles();

      const renderableStyles =
        filteredStyles.filter(
          (style) => {
            return Boolean(
              style.image
            );
          }
        );

      const displayStyles =
        renderableStyles.slice(
          0,
          limit
        );

      grid.replaceChildren();

      displayStyles.forEach(
        (style) => {
          grid.appendChild(
            createCard(style)
          );
        }
      );

      grid.hidden =
        displayStyles.length === 0;
    };

    const updateActiveButton = (
      selectedButton
    ) => {
      filterButtons.forEach(
        (button) => {
          const isActive =
            button ===
            selectedButton;

          button.classList.toggle(
            'aw-style-file__length-link--active',
            isActive
          );

          button.setAttribute(
            'aria-pressed',
            isActive
              ? 'true'
              : 'false'
          );
        }
      );
    };

    filterButtons.forEach(
      (button) => {
        button.addEventListener(
          'click',
          () => {
            activeLength =
              button.dataset.styleLength ||
              'all';

            updateActiveButton(
              button
            );

            render();
          }
        );
      }
    );

    const fetchStylesPage = async (
      page
    ) => {
      const url =
        new URL(
          window.location.href
        );

      url.hash = '';

      url.searchParams.delete(
        'sections'
      );

      url.searchParams.delete(
        'section_id'
      );

      url.searchParams.set(
        'section_id',
        sectionId
      );

      url.searchParams.set(
        pageParam,
        String(page)
      );

      const response =
        await fetch(
          url.toString(),
          {
            credentials:
              'same-origin',

            headers: {
              'X-Requested-With':
                'XMLHttpRequest'
            }
          }
        );

      if (!response.ok) {
        throw new Error(
          `AW Style File: page ${page} fetch failed (${response.status})`
        );
      }

      const html =
        await response.text();

      const documentFragment =
        new DOMParser()
          .parseFromString(
            html,
            'text/html'
          );

      const pageData =
        documentFragment
          .querySelector(
            '[data-style-data]'
          );

      if (!pageData) {
        throw new Error(
          `AW Style File: page ${page} data not found`
        );
      }

      return parseStyles(
        pageData
      );
    };

    const loadAllStyles = async () => {
      if (totalPages <= 1) {
        styles =
          sortStylesByDisplayOrder(
            styles
          );

        render();

        console.log(
          '[AW Style File: loaded]',
          {
            expected:
              sourceTotal,

            total:
              styles.length,

            withImage:
              styles.filter(
                (style) =>
                  Boolean(
                    style.image
                  )
              ).length,

            firstStyles:
              styles
                .filter(
                  (style) =>
                    Boolean(
                      style.image
                    )
                )
                .slice(0, 10)
                .map(
                  (style) => ({
                    title:
                      style.title,

                    displayOrder:
                      style.displayOrder
                  })
                )
          }
        );

        return;
      }

      const requests =
        [];

      for (
        let page = 2;
        page <= totalPages;
        page += 1
      ) {
        requests.push(
          fetchStylesPage(
            page
          )
        );
      }

      const results =
        await Promise.allSettled(
          requests
        );

      const additionalStyles =
        [];

      results.forEach(
        (result, index) => {
          const page =
            index + 2;

          if (
            result.status ===
            'fulfilled'
          ) {
            additionalStyles.push(
              ...result.value
            );

            return;
          }

          console.error(
            `AW Style File: page ${page} load error`,
            result.reason
          );
        }
      );

      const mergedStyles = [
        ...styles,
        ...additionalStyles
      ];

      const styleMap =
        new Map();

      mergedStyles.forEach(
        (style, index) => {
          const key =
            style.handle ||
            style.url ||
            `${style.title}-${index}`;

          if (
            !styleMap.has(key)
          ) {
            styleMap.set(
              key,
              style
            );
          }
        }
      );

      styles =
        sortStylesByDisplayOrder(
          Array.from(
            styleMap.values()
          )
        );

      render();

      console.log(
        '[AW Style File: all loaded]',
        {
          pages:
            totalPages,

          expected:
            sourceTotal,

          total:
            styles.length,

          withImage:
            styles.filter(
              (style) =>
                Boolean(
                  style.image
                )
            ).length,

          firstStyles:
            styles
              .filter(
                (style) =>
                  Boolean(
                    style.image
                  )
              )
              .slice(0, 10)
              .map(
                (style) => ({
                  title:
                    style.title,

                  length:
                    style.length,

                  displayOrder:
                    style.displayOrder
                })
              ),

          byLength: {
            short:
              styles.filter(
                (style) =>
                  style.length ===
                    'ショート' &&
                  Boolean(
                    style.image
                  )
              ).length,

            bob:
              styles.filter(
                (style) =>
                  style.length ===
                    'ボブ' &&
                  Boolean(
                    style.image
                  )
              ).length,

            medium:
              styles.filter(
                (style) =>
                  style.length ===
                    'ミディアム' &&
                  Boolean(
                    style.image
                  )
              ).length,

            long:
              styles.filter(
                (style) =>
                  style.length ===
                    'ロング' &&
                  Boolean(
                    style.image
                  )
              ).length,

            mrs:
              styles.filter(
                (style) =>
                  style.length ===
                    'ミセス' &&
                  Boolean(
                    style.image
                  )
              ).length
          }
        }
      );
    };

    let resizeTimer =
      null;

    window.addEventListener(
      'resize',
      () => {
        window.clearTimeout(
          resizeTimer
        );

        resizeTimer =
          window.setTimeout(
            () => {
              render();
            },
            150
          );
      }
    );

    render();

    loadAllStyles();
  })();